import styles from "./Loader.module.css";

export function Loader({}: {
  resource?: string;
  current?: number;
  max?: number;
  action?: string;
}) {
  return (
    <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
      <div
        className={`relative left-1/2 -translate-x-1/2 ${styles.spinner}`}
      />
    </div>
  );
}
